module.exports = __webpack_public_path__ + "teqbahn-assets/media/23.1754659b.jpg";